import { useCallback } from "react";
import { useParams } from "wouter";
import { useQuery } from "../database/database";
import { Warband } from "../engine/Warband";
import { latest } from "../engine/latest";

export function useLocalWarband() {
  const params = useParams<{ warbandId: string }>();

  const result = useQuery(
    useCallback(
      (db) => db.warbands.getOne(params.warbandId),
      [params.warbandId],
    ),
    `warband:${params.warbandId}`,
  );

  return result.mapSuccess((data) => new Warband(latest, data));
}
